<template>
  <div>
    <ts-card-wrapper class="no-padding-top">
      <div class="d-flex justify-content-between">
        <div class="ts-flex ts-items-center ts-space-x-3">
          <ts-button
            class="btn-block"
            outline
            color="success"
            @click.prevent="exportExcel"
            :waiting="exporting"
            ><i class="fas fa-file-excel"></i> {{ $t('excel') }}</ts-button
          >
        </div>
        <div class="d-flex">
          <ts-input
            v-model="search"
            :placeholder="$t('search')"
            style="width: 250px"
            class="inline-block"
          />
        </div>
      </div>
    </ts-card-wrapper>
    <ts-loading-banner :loading="loading">
      <div class="ts-overflow-auto">
        <ts-table :records="resources" :loading="loading">
          <template v-slot:thead>
            <tr>
              <th
                v-for="(columns, index) in columnHeader[0]"
                :key="index"
                :value="columns"
                :rowspan="
                  columns == 'barcode' || columns == 'product_name_en' ? 2 : 1
                "
                :colspan="
                  columns == 'barcode' || columns == 'product_name_en'
                    ? 1
                    : colspan
                "
                style="vertical-align: middle !important"
                class="ts-uppercase ts-bg-gray-200 ts-border-r ts-border-gray-500 ts-whitespace-no-wrap ts-text-center"
              >
                {{ columns.replaceAll('_', ' ') }}
              </th>
            </tr>
            <tr>
              <th
                v-for="(columns, index) in columnHeader[1]"
                :key="index"
                :value="columns"
                class="ts-uppercase ts-bg-gray-200 ts-border-r ts-border-gray-500 ts-whitespace-no-wrap ts-text-center"
              >
                {{ columns }}
              </th>
            </tr>
          </template>
          <template v-slot="{ record }">
            <td
              v-for="columns in columnsList"
              :key="columns"
              :value="columns"
              class="ts-whitespace-no-wrap"
              :class="
                columns == 'barcode' || columns == 'product_name_en'
                  ? 'ts-text-left'
                  : 'ts-text-center'
              "
            >
              {{ record[columns.toLowerCase()] }}
            </td>
          </template>
        </ts-table>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import * as FileDownload from 'downloadjs'
import { trim } from 'lodash'

export default {
  name: 'summary',
  data() {
    return {
      loading: false,
      showForm: false,
      exporting: false,
      columnHeader: [],
      columnsList: []
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('report/inventoryListByWarehouse', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.report.inventoryListByWarehouse.search
      },
      set(newValue) {
        this.$store.commit(
          'report/inventoryListByWarehouse/SET_SEARCH',
          newValue
        )
        this.$store.commit('report/inventoryListByWarehouse/RESET_CURRENT_PAGE')
      }
    },
    colspan() {
      if (this.columnHeader) {
        console.log(this.columnHeader[1].length, this.columnHeader[0])
        return this.columnHeader[1].length / (this.columnHeader[0].length - 2)
      }
      return 1
    }
  },
  methods: {
    async fetchData(attributes) {
      this.loading = true
      await this.$store.commit(
        'report/inventoryListByWarehouse/SET_REPORT_TYPE',
        1
      )
      await this.$store
        .dispatch('report/inventoryListByWarehouse/getHeader')
        .then(response => {
          this.columnHeader = response.column_header
          this.columnsList = response.column_list
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })

      await this.$store
        .dispatch('report/inventoryListByWarehouse/fetch', {
          ...attributes
        })
        .then(() => {})
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
        .finally(() => (this.loading = false))
    },
    exportExcel() {
      this.exporting = true
      this.errors = new Errors()
      this.$store
        .dispatch('report/inventoryListByWarehouse/exportExcel')
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.exporting = false))
    },
    notice(not) {
      this.$Notice[not.type]({
        title: 'Product Addon Info',
        desc: not.text
      })
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('report/productAddonInfo/RESET_STATE')
    next()
  }
}
</script>
<style scoped>
.no-padding-top {
  padding: 0 1rem 1rem 1rem;
}
</style>
